import React, { useReducer, useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isEmpty, isNotEmpty, parseIfString } from '../lib/ep';

import ActionLink from '../components/builder/ActionLink';
import ButtonCollection from '../components/builder/ButtonCollection';
import { Checkbox } from '../components/builder/Checkbox';
import { DynamicForm } from '../components/builder/DynamicForm';
import EmailField from '../components/builder/EmailField';
import Input from '../components/builder/Input';
import Model from '../components/builder/Model';
import PhoneField from '../components/builder/PhoneField';
import SaveButton from '../components/builder/SaveButton';
import TimeCounterSimple from '../components/builder/TimeCounterSimple';

import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText';
import FloatingLayerPublic from '../components/front/FloatingLayerPublic';
import { SimpleWinnerContent } from '../components/prizes/WinnerContent';
import { localizeFields } from '../components/builder/DynamicFields';
import ActionButton from '../components/builder/ActionButton';

export const rejectPrize = (promotion_id, prize_id,cb) => {
	fetch(`/users/reject_prize/${promotion_id}`, {
		method:'POST',
		body: JSON.stringify({prize_id:prize_id}),
	}).then((response) => response.json()).then((response) => {
		if(cb != undefined) {
			cb(response)
		}
	})
}

const Wrapper = (props) => {
	const image = props?.image ?? false;
	const description = props?.description ?? false;

	return (
		<div class="flex_cols">
			{(image !== false) && (
				<div class="flex_col col_1">
					<div class="register_media_flex">
						<img src={image} style={{maxWidth:'100%'}} />
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<div class="register_form_flex" style={{width:'100%'}}>
					{(description !== false && description != "") && (
						<LeveledHTMLText
							_class={{ other:'gui_main_text_color_on_bg' }}
						>{description}</LeveledHTMLText>
					)}

					<article>
						{props.children}
					</article>
				</div>
			</div>
		</div>
	)
};

const ClaimPromoFull = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_toc_layer, setDisplayTocLayer ] = useState(false);
	const [ display_policy_layer, setDisplayPolicyLayer ] = useState(false);
	const [ display_reject_layer, setDisplayRejectLayer ] = useState(false);

	const prize_type = props?.prize_type ?? {};
	const user = props.user?.User ?? {};
	const is_builder = props.is_builder ?? false;

	const getPrize = () => {
		const _p = (props?.prizes ?? []).find((p) => p.Prize.id == props.prize_id);
		if(_p == undefined) return {};
		return _p?.Prize ?? {};
	};

	const getPrizeType = () => {
		const _p = (props?.prizes ?? []).find((p) => p.Prize.id == props.prize_id);
		if(_p == undefined) return {};
		return _p?.PrizeType ?? {};
	};
	
	const isPrizeRejectable = () => {
		const _p = (props?.prizes ?? []).find((p) => p.Prize.id == props.prize_id);
		if(_p == undefined || _p.PrizeType == undefined) return false;
		if(isNotEmpty(_p.PrizeType, 'rejectable', ["", " ", "0"])) return true;
		return false;
	};

	const getPromoClaim = () => {
		const _p = (props?.prizes ?? []).find((p) => p.Prize.id == props.prize_id);
		if(_p == undefined) return {};
		return _p?.PromoClaim ?? {};
	};

	const getExpiredSeconds = () => {
		const _p = getPrize();
		const _pt = getPrizeType();
		const _pc = getPromoClaim();
		if(_p == undefined) return 0;
		if(!_pt.redeemable && !_pt.claimable) return 0;
		if(_pc.id != undefined) return 0;
		if(_p.seconds_to_claim > 0) return 0;
		return Math.abs(_p.seconds_to_claim);
	};

	const promotion = props?.promotion?.Promotion ?? false;

	const login_type = promotion?.login_type ?? '1';	// by default: identified_mode
	const is_anonymous = (login_type == '3') ? true : false;
	const is_rejectable = isPrizeRejectable();

	const expired_seconds = getExpiredSeconds();
	const [ state, dispatch ] = useReducer(( state, action ) => {
		switch (action.type) {
			case 'NO_PRIZES':
				return { ...state, status:'no_prize' };

			case 'CHECKING':
				return { ...state, status:'checking' };

			case 'MAIL_SENT':
				return { ...state, status:'mail_sent' };

			case 'SET_PRIZES':
				return { ...state, prizes:action.prizes, status:'prize_list' };
		
			case 'CLAIM_FORM':
				return { ...state, prize:action.prize, status:'claim_form' };

			case 'SET_ERRORS':
				return { ...state,errors:action.errors };

			case 'SET_USER_FORM':
				let new_form = { ...state.form, ...action.user };
				for(let i in new_form) {
					if(new_form[i] == '') delete new_form[i];
				}

				if(action?.is_valid_prize != undefined) {
					state.is_valid_prize = action.is_valid_prize;
				}

				if(action?.is_valid != undefined) {
					state.is_valid = action.is_valid;
				}

				return { ...state, form:new_form};

			case 'SET_USER_ERROR':
				if(state.user_errors === false) state.user_errors = {};

				return {
					...state,
					user_errors:{
						...state.user_errors,
						[action.k]:action.v,
					},
				};

			case 'CHANGE_USER':
				if(state.user_errors[action.k]!= undefined) delete state.user_errors[action.k];

				return {
					...state,
					user:{
						...state.user,
						[action.k]:action.v,
					},
					user_errors:{...state.user_errors}
				};

			case 'TOGGLE_ERRORS':
				return { ...state, showFormErrors:!state.showFormErrors };

			case 'SHOW_ERRORS':
				return { ...state, showFormErrors:true };

			case 'SET_CLAIMED':
				return { ...state, status:'thanks' };
			
			default:
				return state;
		}
	}, {
		status:(props.claim != false && (props?.claim?.PromoClaim?.status ?? '0') != '0') ? 'claimed' : ((expired_seconds > 0) ? 'expired' : 'landing'),
		prizes:[],
		prize:props.prize,
		form:null,
		user:{
			first_name:(user.first_name != "No name" && !is_anonymous) ? user.first_name : "",
			last_name:(!is_anonymous) ? user.last_name : '',
			email:user.email,
			phone:user.phone,
		},
		user_errors: false,
		showFormErrors:false,
		is_valid:true,
		is_valid_prize:true,
	});

	if(promotion === false) return null;

	const userForm = (user, is_valid) => {
		dispatch({ type:'SET_USER_FORM', user, is_valid });
	};

	const userFormPrize = (user, is_valid_prize) => {
		dispatch({ type:'SET_USER_FORM', user, is_valid_prize });
	};

	const changeUser = (k, v) => {
		dispatch({ type:'CHANGE_USER', k, v });
	};

	let has_toc = (isNotEmpty(promotion, 'toc') || isNotEmpty(promotion, 'external_toc_url')) ? true : false;
	if(promotion?.hide_toc ?? false) has_toc = false;

	let has_policy = (isNotEmpty(promotion, 'policy') || isNotEmpty(promotion, 'external_policy_url')) ? true : false;
	if(promotion?.hide_policy ?? false) has_policy = false;

	//promotion.need_phone = promotion.need_phone == '1' ? true : false; //NO volem Activar al form
	const submitClaim = (cb) => {
		let has_errors = false;
		if(has_toc && state.user.toc == undefined) {
			dispatch({ type:'SET_USER_ERROR', k:'toc', v:"This field cannot be left empty" });
			has_errors = true;
		}
		
		if(has_policy && state.user.policy == undefined) {
			dispatch({ type:'SET_USER_ERROR', k:'policy', v:"This field cannot be left empty" });
			has_errors = true;
		}

		if((promotion.claim_phone) && state.user.phone == undefined) {
			dispatch({ type:'SET_USER_ERROR', k:'phone', v:"This field cannot be left empty" });
			has_errors = true;
		}

		const mandatory = ['email', 'first_name', 'last_name'];
		mandatory.map((field) => {
			if(state.user[field] == "" || state.user[field] == null) {
				dispatch({ type:'SET_USER_ERROR', k:field, v:"This field cannot be left empty" });
				has_errors = true;
			}
		});

		if(!state.is_valid || !state.is_valid_prize) {
			has_errors = true;
		}

		if(has_errors) {
			dispatch({ type:'SHOW_ERRORS' });
			if(cb != undefined) cb();
			return;
		}

		let data = {
			claim:JSON.stringify(state.form),
			user:JSON.stringify(state.user),
			prize_id:props.prize_id
		};

		$.post(`/users/claim_prize/${promotion.id}`, data, (response) => {
			dispatch({type:'SET_CLAIMED'});
			if(cb != undefined) cb();
			if(props.onClaim != undefined) props.onClaim(props.prize_id, response.claim);
		}, 'JSON');
	};

	const claim_image = (isNotEmpty(promotion, 'full_claim_image')) ? promotion.full_claim_image : false;

	let just_claimed = false;
	if(props?.prizes != undefined && (props?.prizes.find((p) => p.Prize.id == props.prize_id)?.Prize?.claimed ?? false)) just_claimed = true;

	const claim = props?.claim?.PromoClaim ?? {};

	let status_log = [];

	if(is_builder === false){
		status_log.push({ key:'pending', date:props?.user_prizes?.[0]?.Prize?.created ?? null });
		if(just_claimed || isNotEmpty(claim, 'claim_date')) {
			status_log.push({ key:'claimed', date:claim.claim_date });
		}
		if(isNotEmpty(claim, 'progress_date')) {
			status_log.push({ key:'progress', date:claim.progress_date });
		}
		if(isNotEmpty(claim, 'delivered_date')) {
			status_log.push({ key:'delivered', date:claim.delivered_date });
		}
		if(isNotEmpty(claim, 'cancelled_date')) {
			status_log.push({ key:'cancelled', date:claim.cancelled_date });
		}
		if(state.status == 'expired') {
			status_log.push({ key:'expired', date:EPDateSubtractAndFormat(null, 'seconds', expired_seconds, 'YYYY-MM-DD HH:mm:ss') });
		}
	}

	if(['expired'].includes(state.status)) {
		// TO DO: avaluar què mostrem en aquest cas
		return (
			<Wrapper
				image={claim_image}
			>
				<LeveledHTMLText>
					<h1>{i18n("Time expired")}</h1><p>{i18n("The period to claim your prize has ended.")}</p>
				</LeveledHTMLText>
			</Wrapper>
		)
	}

	const display_instructions = (isNotEmpty(prize_type, 'instructions_post_claim')) ? true : false;

	const _prize = getPrize();

	if(['claimed'].includes(state.status)) {
		return (
			<Wrapper
				image={claim_image}
				//description={claim_description}
			>
				<SimpleWinnerContent
					prize={props?.prizes.find((p) => p.Prize.id == props.prize_id)}
					status_log={status_log}
					intl={props.intl}
				/>

				<ButtonCollection
					_class={{ other:'gui_not_in_top_big' }}
				>
					<ActionLink
						onClick={props.back}
					>Go back</ActionLink>
				</ButtonCollection>
			</Wrapper>
		)
	}

	if(state.status == 'thanks' || just_claimed) {
		const claim_done_description_default = `<h1>${i18n("Thank you!")}</h1><p>${i18n("You have successfully claimed your prize.")}</p>`;

		return (
			<Wrapper
				image={claim_image}
				description={(isNotEmpty(promotion, 'claim_done_description')) ? promotion.claim_done_description : claim_done_description_default}
			>
				<SimpleWinnerContent
					prize={props?.prizes.find((p) => p.Prize.id == props.prize_id)}
					status_log={status_log}
					just_claimed={true}
					intl={props.intl}
				/>

				<ButtonCollection
					_class={{ other:'gui_not_in_top_big' }}
				>
					<ActionLink
						onClick={props.back}
					>Go back</ActionLink>
				</ButtonCollection>
			</Wrapper>
		)
	}

	let toc_label = false;
	if(has_toc) {
		let toc_link = null;
		if(promotion.external_toc_url != undefined && promotion.external_toc_url != '') {
			toc_link = <ActionLink _href={promotion.external_toc_url} _target="_blank">Terms and conditions</ActionLink>;
		} else {
			toc_link = <ActionLink onClick={() => setDisplayTocLayer(!display_toc_layer)}>Terms and conditions</ActionLink>;
		}

		let toc_label_raw = promotion?.custom_labels?.toc_label ?? "";
		if(toc_label_raw == "") toc_label_raw = "I have read and accept the {toc}.";
		toc_label = <FormattedMessage id={i18n(toc_label_raw.replace("%s", "{toc}"))} values={{ toc:toc_link }} />;
	}

	let policy_label = false;
	if(has_policy) {
		let policy_link = null;
		if(promotion.external_policy_url != undefined && promotion.external_policy_url != '') {
			policy_link = <ActionLink _href={promotion.external_policy_url} _target="_blank">Privacy policy</ActionLink>;
		} else {
			policy_link = <ActionLink onClick={() => setDisplayPolicyLayer(!display_policy_layer)}>Privacy policy</ActionLink>;
		}

		let policy_label_raw = promotion?.custom_labels?.policy_label ?? "";
		if(policy_label_raw == "") policy_label_raw = "***I have read and accept the {policy}.";
		policy_label = <FormattedMessage id={i18n(policy_label_raw.replace("%s", "{policy}"))} values={{ policy:policy_link }} />
	}

	const generic_toc_link = `https://${window.domain_url}/promo_terms/${promotion.id}`;
	const generic_policy_link = `https://${window.domain_url}/policy/${promotion.id}`;
	const submit_label = (isNotEmpty(promotion, 'claim_button_label')) ? promotion.claim_button_label : "Submit";

	let enable_edit_name = promotion?.hide_name ?? false;
	if(is_anonymous){
		enable_edit_name = true;
	}

	const claim_counter_seconds = _prize.seconds_to_claim;
	let claim_time_format = `{m}${i18n("m")} {s}${i18n("s")}`;
	if(claim_counter_seconds > 0) {
		if(claim_counter_seconds >= 60 * 60) claim_time_format = `{h}${i18n("h")} {m}${i18n("m")} {s}${i18n("s")}`;
		if(claim_counter_seconds > 24 * 60 * 60) claim_time_format = `<span class="days">{d2}&nbsp;${i18n("day")}</span> {h}${i18n("h")}`;
		if(claim_counter_seconds > 48 * 60 * 60) claim_time_format = `<span class="days">{d2}&nbsp;${i18n("days")}</span> {h}${i18n("h")}`;
	}

	if(typeof promotion.claim_form == 'string') promotion.claim_form = JSON.parse(promotion.claim_form);

	console.log(prize_type)
	const default_claim_description = `<h1><strong>You won a {prize}!</strong></h1><p>${i18n("Fill in this form to claim your prize.")}</p>`;
	const claim_description = props.intl.formatMessage({ id:promotion?.claim_description || default_claim_description }, { prize:prize_type.title });

	return (
		<Wrapper 
			description={claim_description} 
			image={claim_image}
		>
			{(claim_counter_seconds > 0) && (
				<TimeCounterSimple
					seconds={claim_counter_seconds}
					hide_days={false}
					hide_hours={false}
					execute_countdown={true}
					custom_render={`${i18n("Time left")}: <strong class="gui_not_in_start_tiny">${claim_time_format}</strong>`}
					onFinish={() => {
						window.location.reload();
					}}
					_class={{ other:'time_to_claim' }}
				/>
			)}

			<Model
				classname="gui_form_register template_module gui_main_text_color_on_bg"
				model={state.user}
				change={changeUser}
				errors={state.user_errors}
			>
				<Input
					disabled={!(enable_edit_name || isEmpty(user, 'first_name')) ? true : false}
					name="first_name"
					_field_class='is_2_columned'
					label_props={{
						mandatory:true,
					}}
				>First name</Input>

				<Input
					disabled={!(enable_edit_name || isEmpty(user, 'last_name')) ? true : false}
					name="last_name"
					_field_class='is_2_columned'
					label_props={{
						mandatory:true,
					}}
				>Last name</Input>

				<EmailField
					disabled={(isNotEmpty(user, 'email')) ? true : false}
					name="email"
					label_props={{
						mandatory:true,
					}}
				>Email</EmailField>

				{(promotion.claim_phone) && (
					<PhoneField
						disabled={isNotEmpty(user, 'phone') ? true : false}
						preferred_countries={promotion?.phone_field_preferred_countries ?? []}
						avail_countries={null}
						only_available={false}
						name="phone"
						label_props={{
							mandatory:true,
						}}
					>Telephone</PhoneField> 
				)}
			</Model>

			{(promotion.claim_form) && (
				<DynamicForm
					field_config={{
						signature:{
							auto_url:`/users/upload/${promotion.id}`,
							auto_type:"custom_fields",
							is_builder:true,
						},
						attach:{
							auto_url:`/users/upload/${promotion.id}`,
							auto_type:"custom_fields",
							is_builder:true,
						}
					}}
					public_form={true}
					form={localizeFields(promotion.claim_form,props.locale)}
					onChange={userForm}
					user={props.claim?.PromoClaim?.claim_data}
					showFormErrors={state.showFormErrors}
					loc={props.loc}
					model_classes="gui_form_register template_module gui_main_text_color_on_bg"
				/>
			)}

			{(prize_type.claim_form != undefined && prize_type.claim_form != '[]') && (
				<DynamicForm
					field_config={{
						signature:{
							auto_url:`/users/upload/${promotion.id}`,
							auto_type:"custom_fields",
							is_builder:true,
						},
						attach:{
							auto_url:`/users/upload/${promotion.id}`,
							auto_type:"custom_fields",
							is_builder:true,
						}
					}}
					public_form={true}
					form={localizeFields(parseIfString(prize_type?.claim_form ?? []),props.locale)}
					onChange={userFormPrize}
					showFormErrors={state.showFormErrors}
					user={props.claim?.PromoClaim?.claim_data}
					loc={props.loc}
					model_classes="gui_form_register template_module gui_main_text_color_on_bg"
				/>
			)}

			{(isNotEmpty(promotion, 'claim_disclaimer')) && (
				<div
					class="legal_text mod_align_left gui_main_text_color_on_bg gui_text_block"
					dangerouslySetInnerHTML={{
						__html:promotion.claim_disclaimer.replace('\n', "<br />"),
					}}
				/>
			)}

			{(has_toc || has_policy) && (
				<Model
					classname="gui_form_register template_module gui_main_text_color_on_bg"
					model={state.user}
					errors={state.user_errors}
					change={changeUser}
				>
					{(has_toc) && (
						<Checkbox
							_class={{ first:true }}
							name="toc"
						>{toc_label}</Checkbox>
					)}

					{(has_policy) && (
						<Checkbox
							_class={(has_toc === false) ? { first:true } : null}
							name="policy"
						>{policy_label}</Checkbox>
					)}
				</Model>
			)}

			<div
				class="template_module mod_align_center register_call_to_action_flex is_react_cta"
				style={{
					display:'flex',
					flexDirection:'column',
					gap:'1em',
				}}
			>
				<div class="finalize_form enter flex_button gui_big_button">
					<SaveButton
						_fullclass=""
						onClick={(e, cb) => submitClaim(cb)}
					>{submit_label}</SaveButton>
				</div>

				{(is_rejectable) && (
					<ActionLink
						onClick={() => setDisplayRejectLayer(true)}
					>I don't want it</ActionLink>
				)}
			</div>

			{(display_reject_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Prize rejection")}</h1>`}
					backButton={() => setDisplayRejectLayer(false)}
				>
					<LeveledHTMLText>
						<p>{i18n("If you don't want to enjoy this prize, click the button below to release it and let someone else enjoy it.")}</p>
					</LeveledHTMLText>

					<div class="gui_flexbox_auto gui_flex_col gui_flex_align_center gui_flex_center gui_not_in_top" style={{ gap:'0.5em' }}>
						<ButtonCollection
							_class={{ other:'flex_button' }}
						>
							<ActionButton
								onClick={props.goRejectConfirm}
								_fullclass=""
							>I don't want it</ActionButton>
						</ButtonCollection>

						<ActionLink
							onClick={() => setDisplayRejectLayer(false)}
						>Cancel</ActionLink>
					</div>
				</FloatingLayerPublic>
			)}

			{(display_toc_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Terms and conditions")}</h1>`}
					backButton={() => setDisplayTocLayer(false)}
				>
					<div dangerouslySetInnerHTML={{ __html:promotion.toc.replace(/\n/g, '<br />') }} />

					<ul class="related_link original_color_item">
						<li class="link">
							<ActionLink
								_href={generic_toc_link}
								_target="_blank"
								_class={{ other:'toc_link' }}
								autotranslate={false}
							>{generic_toc_link}</ActionLink>
						</li>
					</ul>
				</FloatingLayerPublic>
			)}

			{(display_policy_layer) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Privacy policy")}</h1>`}
					backButton={() => setDisplayPolicyLayer(false)}
				>
					<div dangerouslySetInnerHTML={{ __html:promotion.policy.replace(/\n/g, '<br />') }} />

					<ul class="related_link original_color_item">
						<li class="link">
							<ActionLink
								_href={generic_policy_link}
								_target="_blank"
								_class={{ other:'policy_link toc_link' }}
								autotranslate={false}
							>{generic_policy_link}</ActionLink>
						</li>
					</ul>
				</FloatingLayerPublic>
			)}
		</Wrapper>
	)
}

export default injectIntl(ClaimPromoFull);